(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ms-cart-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-cart-extras')) {
  customElements.define('ms-cart-extras', class extends HTMLElement {
    connectedCallback() { queueMicrotask(() => { if (this.isConnected) this.deduplicate(); }); }
    deduplicate() {
      const seen = new Set();
      let shown = 0;
      const limit = Math.max(1, Math.min(12, Number(this.dataset.limit || 6)));
      for (const group of this.querySelectorAll('ms-product-extras')) {
        let visible = 0;
        for (const card of group.querySelectorAll('[data-extra-card]')) {
          if (card.hidden) continue;
          const form = card.querySelector('form');
          const input = form?.querySelector('[name="id"]');
          const key = input?.tagName === 'INPUT' ? input.value : card.dataset.extraProduct;
          if (!key || seen.has(key) || shown >= limit) { card.hidden = true; continue; }
          seen.add(key); shown++; visible++;
        }
        group.hidden = !visible;
      }
      this.hidden = shown === 0;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-product-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-product-extras')) {
  customElements.define('ms-product-extras', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      if (this.hasAttribute('data-separate-addons')) { this.connectStandalone(signal); return; }
      this.cards = [...this.querySelectorAll('[data-extra-card]')];
      this.cards.forEach(card => { card.variants = JSON.parse(card.querySelector('[data-extra-variants]').textContent); });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-extra-choice]');
        if (button && !button.disabled) {
          const selected = button.getAttribute('aria-pressed') === 'true';
          if (button.closest('[data-frame-match]')) this.cards.filter(card => card.hasAttribute('data-frame-match')).forEach(card => this.select(card, false));
          this.select(button.closest('[data-extra-card]'), !selected);
        }
        if (event.target.closest('[data-no-frame]')) this.cards.filter(card => card.hasAttribute('data-frame-match')).forEach(card => this.select(card, false));
        this.notify();
      }, {signal});
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-extra-select]')) return;
        const card = event.target.closest('[data-extra-card]');
        this.setVariant(card, card.variants.find(variant => String(variant.id) === event.target.value));
        this.notify();
      }, {signal});
      document.addEventListener('change', event => {
        if (!event.target.matches('input[data-option-position]') || event.target.form !== document.getElementById(this.dataset.mainForm)) return;
        this.variantPending = true;
        this.cards.filter(card => card.hasAttribute('data-frame-match') || card.hasAttribute('data-shoe-fit')).forEach(card => {
          this.select(card, false);
          card.querySelector('[data-extra-choice]').disabled = true;
        });
        this.notify();
      }, {capture:true, signal});
      document.addEventListener('variant:change', event => {
        if (event.target !== document.getElementById(this.dataset.mainForm)) return;
        this.variantPending = false;
        this.matchFrames(event.detail.variant);
        this.matchShoes(event.detail.variant?.options?.[Number(this.dataset.shoeSizePosition)]);
        this.notify();
      }, {signal});
      this.matchShoes(this.dataset.selectedShoeSize);
      this.notify();
    }
    connectStandalone(signal) {
      document.addEventListener('change', event => {
        if (!event.target.matches('input[data-option-position]') || event.target.form !== document.getElementById(this.dataset.mainForm)) return;
        this.standaloneVariantPending = true;
        this.matchStandaloneShoes(null);
      }, {capture:true, signal});
      document.addEventListener('variant:change', event => {
        if (event.target !== document.getElementById(this.dataset.mainForm)) return;
        this.standaloneVariantPending = false;
        this.matchStandaloneShoes(event.detail.variant?.options?.[Number(this.dataset.shoeSizePosition)]);
        this.querySelector('[data-extra-status]').textContent = '';
      }, {signal});
      this.addEventListener('change', event => {
        if (!event.target.matches('select[name="id"]')) return;
        const card = event.target.closest('[data-extra-card]');
        card.querySelector('[data-extra-price]').textContent = event.target.selectedOptions[0].dataset.price;
        this.querySelector('[data-extra-status]').textContent = '';
      }, {signal});
      this.addEventListener('submit', event => {
        const card = event.target.closest('[data-shoe-fit]');
        if (card && (card.hidden || this.standaloneVariantPending || event.target.elements.id?.value !== card.dataset.matchedVariant)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, {capture:true, signal});
      this.addEventListener('variant:add', () => {
        this.querySelector('[data-extra-status]').textContent = this.dataset.addedMessage;
      }, {signal});
      this.addEventListener('cart:error', event => {
        this.querySelector('[data-extra-status]').textContent = event.detail?.error || this.dataset.errorMessage;
      }, {signal});
      this.matchStandaloneShoes(this.dataset.selectedShoeSize);
    }
    matchStandaloneShoes(value) {
      const numeric = String(value || '').trim().match(/^(?:EU\s*)?(\d+(?:[.,]\d+)?)\s*(?:EU)?$/i);
      const size = this.dataset.shoeSizePosition !== '' && numeric ? Number(numeric[1].replace(',', '.')) : null;
      this.querySelectorAll('[data-shoe-fit]').forEach(card => {
        const variants = JSON.parse(card.querySelector('[data-extra-variants]').textContent);
        const selected = size !== null && variants.find(variant => {
          const range = variant.title.match(/\((\d+(?:[.,]\d+)?)\s*[-–]\s*(\d+(?:[.,]\d+)?)\)/);
          return range && size >= Number(range[1].replace(',', '.')) && size <= Number(range[2].replace(',', '.'));
        });
        card.hidden = !selected;
        card.dataset.matchedVariant = selected ? String(selected.id) : '';
        const input = card.querySelector('[name="id"]');
        if (input.tagName === 'SELECT') {
          [...input.options].forEach(option => {
            if (!option.value) return;
            option.disabled = option.value !== card.dataset.matchedVariant;
            option.hidden = option.disabled;
          });
        }
        input.value = card.dataset.matchedVariant;
        input.disabled = !selected;
        card.querySelector('[type="submit"]').disabled = !selected;
        if (selected) card.querySelector('[data-extra-price]').textContent = selected.price;
      });
    }
    select(card, selected) {
      const button = card.querySelector('[data-extra-choice]');
      button.setAttribute('aria-pressed', String(selected));
      if (!button.classList.contains('ms-extras__frame-card')) button.textContent = selected ? this.dataset.selectedLabel : button.dataset.selectLabel;
    }
    setVariant(card, variant) {
      const button = card.querySelector('[data-extra-choice]');
      button.dataset.variantId = variant?.id || '';
      button.dataset.price = variant?.amount ?? '';
      button.disabled = !variant || this.busy || this.variantPending;
      if (!variant) this.select(card, false);
      if (variant) {
        const price = card.querySelector('[data-extra-price]');
        if (price) price.textContent = variant.price;
      }
    }
    dimension(value) {
      const match = String(value || '').match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
      return match ? match.slice(1).map(number => Number(number.replace(',', '.'))).sort((a,b) => a-b).join('x') : null;
    }
    matchFrames(variant) {
      const dimension = variant?.options?.map(value => this.dimension(value)).find(Boolean);
      this.cards.filter(card => card.hasAttribute('data-frame-match')).forEach(card => {
        const selected = dimension && card.variants.find(item => item.options.some(value => this.dimension(value) === dimension));
        this.select(card, false);
        card.hidden = !selected;
        this.setVariant(card, selected);
      });
    }
    matchShoes(value) {
      const numeric = String(value || '').trim().match(/^(?:EU\s*)?(\d+(?:[.,]\d+)?)\s*(?:EU)?$/i);
      const size = this.dataset.shoeSizePosition !== '' && numeric ? Number(numeric[1].replace(',', '.')) : null;
      this.cards.filter(card => card.hasAttribute('data-shoe-fit')).forEach(card => {
        const selected = size !== null && card.variants.find(variant => {
          const range = variant.title.match(/\((\d+(?:[.,]\d+)?)\s*[-–]\s*(\d+(?:[.,]\d+)?)\)/);
          return range && size >= Number(range[1].replace(',', '.')) && size <= Number(range[2].replace(',', '.'));
        });
        this.select(card, false);
        card.hidden = !selected;
        this.setVariant(card, selected);
        const select = card.querySelector('[data-extra-select]');
        if (select) {
          [...select.options].forEach(option => {
            if (option.value) option.disabled = option.hidden = option.value !== String(selected?.id || '');
          });
          select.value = selected?.id || '';
        }
      });
    }
    get items() {
      if (this.hasAttribute('data-separate-addons') || this.variantPending) return [];
      return this.cards.filter(card => !card.hidden).map(card => card.querySelector('[data-extra-choice]'))
        .filter(button => button.getAttribute('aria-pressed') === 'true' && button.dataset.variantId)
        .map(button => ({id:Number(button.dataset.variantId),price:Number(button.dataset.price),
          properties:{_ms_upsell_source:'product_page',_ms_upsell_version:'1'}}));
    }
    setBusy(busy) {
      this.busy = busy;
      this.querySelectorAll('[data-extra-select], [data-no-frame]').forEach(control => { control.disabled = busy; });
      this.cards.forEach(card => {
        const button = card.querySelector('[data-extra-choice]');
        button.disabled = busy || !button.dataset.variantId || this.variantPending;
      });
    }
    reset() { this.cards.forEach(card => this.select(card, false)); this.notify(); }
    notify() {
      const frameSelected = this.cards.some(card => card.hasAttribute('data-frame-match') && card.querySelector('[data-extra-choice]').getAttribute('aria-pressed') === 'true');
      this.querySelector('[data-no-frame]')?.setAttribute('aria-pressed', String(!frameSelected));
      const selection = this.querySelector('[data-frame-selection]');
      if (selection) selection.textContent = this.querySelector('[data-frame-label][aria-pressed="true"]')?.dataset.frameLabel || '';
      const empty = this.querySelector('[data-no-matching-frame]');
      if (empty) empty.hidden = this.cards.some(card => !card.hidden);
      document.getElementById(this.dataset.mainForm)?.querySelector('ms-purchase-total')?.update?.();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-purchase-total"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-purchase-total')) {
  customElements.define('ms-purchase-total', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.form.addEventListener('submit', event => this.submit(event), {capture:true, signal});
      this.form.addEventListener('variant:change', () => this.update(), {signal});
      document.addEventListener('change', event => {
        if (event.target.form !== this.form) return;
        if (event.target.matches('input[data-option-position]')) {
          this.pending = true;
          this.button.disabled = true;
        } else if (event.target.name === 'quantity' || event.target.name === 'selling_plan') this.update();
      }, {capture:true, signal});
      document.addEventListener('input', event => {
        if (event.target.form === this.form && event.target.name === 'quantity') this.update();
      }, {signal});
      queueMicrotask(() => this.update());
    }
    get button() { return this.querySelector('button[type="submit"]'); }
    get extras() {
      return [...document.querySelectorAll('ms-product-extras')].filter(element => element.dataset.mainForm === this.dataset.form);
    }
    get quantity() { return Math.max(1, Number(this.form.elements.quantity?.value || 1)); }
    get items() {
      const unique = new Map();
      this.extras.flatMap(element => element.items || []).forEach(item => unique.set(item.id, item));
      return [...unique.values()];
    }
    update() {
      if (!this.isConnected || !this.form || !this.button) return;
      const busy = this.form.dataset.msBundleBusy === 'true';
      const available = this.dataset.available === 'true';
      this.button.disabled = !available || busy || this.pending || this.extras.some(element => element.variantPending);
      if (!available) return;
      const amount = (Number(this.dataset.price) + this.items.reduce((sum,item) => sum + item.price,0)) * this.quantity;
      const total = new Intl.NumberFormat(this.dataset.locale || 'sv', {
        style:'currency',currency:this.dataset.currency || 'SEK',minimumFractionDigits:2,maximumFractionDigits:2
      }).format(amount / 100);
      const label = `${this.dataset.preorder === 'true' ? this.dataset.preorderLabel : this.dataset.add} · ${total}`;
      const content = this.button.querySelector('button-content');
      if (content) {
        content.textContent = label;
        ['rotated-text','up-text'].forEach(attribute => { if (content.hasAttribute(attribute)) content.setAttribute(attribute,label); });
      } else this.button.textContent = label;
      const property = this.form.querySelector('[data-preorder-property]');
      const note = this.querySelector('[data-preorder-note]');
      if (note) note.style.display = this.dataset.preorder === 'true' ? '' : 'none';
      if (property) property.disabled = this.dataset.preorder !== 'true';
      const payment = this.querySelector('.shopify-payment-button');
      if (payment) payment.hidden = this.items.length > 0;
    }
    async submit(event) {
      if (this.form.dataset.msBundleBusy === 'true' || this.pending || this.button.disabled) {
        event.preventDefault();event.stopImmediatePropagation();return;
      }
      const extras = this.items;
      if (!extras.length) return;
      event.preventDefault();event.stopImmediatePropagation();
      if (!this.form.reportValidity()) return;
      const data = new FormData();
      for (const [key,value] of new FormData(this.form)) {
        if (['id','quantity','selling_plan'].includes(key)) data.append(`items[0][${key}]`,value);
        else if (/^properties\[.+\]$/.test(key)) data.append(`items[0][properties]${key.slice(10)}`,value);
      }
      data.set('items[0][quantity]',String(this.quantity));
      extras.forEach((item,index) => {
        data.set(`items[${index + 1}][id]`,String(item.id));
        data.set(`items[${index + 1}][quantity]`,String(this.quantity));
        for (const [key,value] of Object.entries(item.properties || {})) {
          data.set(`items[${index + 1}][properties][${key}]`,String(value));
        }
      });
      const sections = new Set();
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
      data.set('sections',[...sections].slice(0,5).join(','));
      data.set('sections_url',window.location.pathname);
      const status = this.querySelector('[data-purchase-status]');
      status.textContent = '';
      this.form.dataset.msBundleBusy = 'true';
      this.button.setAttribute('aria-busy','true');
      this.extras.forEach(element => element.setBusy(true));
      this.update();
      const root = window.Shopify.routes.root;
      let added = false;
      try {
        const response = await fetch(`${root}cart/add.js`,{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body:data});
        const result = await response.json();
        if (!response.ok) {
          status.textContent = result.description || result.message || this.dataset.error;
          this.form.dispatchEvent(new CustomEvent('cart:error',{bubbles:true,detail:{error:status.textContent}}));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
          return;
        }
        added = true;
        if (window.themeVariables.settings.cartType === 'page') { window.location.assign(`${root}cart`);return; }
        const cartResponse = await fetch(`${root}cart.js`);
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        const cart = await cartResponse.json();cart.sections = result.sections;
        this.form.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:result.items,cart}}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart}}));
        status.textContent = this.dataset.added;
        this.extras.forEach(element => element.reset());
      } catch {
        if (added) { window.location.assign(`${root}cart`);return; }
        status.textContent = this.dataset.error;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
      } finally {
        delete this.form.dataset.msBundleBusy;
        this.button?.removeAttribute('aria-busy');
        this.extras.forEach(element => element.setBusy(false));
        this.form.querySelector('ms-purchase-total')?.update();
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', event => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-option-position')) return;
  const picker = input.closest('variant-picker[data-ms-variant-required]');
  if (!picker) return;
  const optionCount = picker.querySelectorAll('fieldset.variant-picker__option').length;
  if (picker.querySelectorAll('input[data-option-position]:checked').length >= optionCount) return;
  const label = input.closest('[data-size-value]')?.dataset.sizeValue;
  const selectedValue = input.closest('fieldset')?.querySelector('[data-ms-selected-value]');
  if (selectedValue && label) selectedValue.textContent = label;
  event.stopImmediatePropagation();
}, true);
function msSizeKey(value) {
  const text = String(value).trim().toLowerCase().replace(/,/g, '.');
  const dimension = text.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/);
  if (dimension) {
    const sides = dimension.slice(1).map(Number).sort((a, b) => a - b);
    return [0, sides[0] * sides[1], ...sides];
  }
  const letters = text.split(/[ (\/]/)[0].replace(/-/g, '');
  const names = {xxsmall:-2, xsmall:-1, small:0, medium:1, large:2, xlarge:3, xxlarge:4, s:0, m:1, l:2};
  if (Object.hasOwn(names, letters)) return [1, names[letters]];
  const alpha = letters.match(/^(\d+x?|x+)(s|l)$/);
  if (alpha) {
    const count = /^\d/.test(alpha[1]) ? parseInt(alpha[1], 10) : alpha[1].length;
    return [1, alpha[2] === 's' ? -count : 2 + count];
  }
  const numeric = text.match(/^(?:(?:eu|uk|us)\s*)?(\d+(?:\.\d+)?)(?:\s+(\d+)\/(\d+)|\s*([½⅓⅔¼¾]))?/);
  if (numeric) {
    const fractions = {'½':0.5,'⅓':1/3,'⅔':2/3,'¼':0.25,'¾':0.75};
    return [0, Number(numeric[1]) + (numeric[2] ? Number(numeric[2]) / Number(numeric[3]) : fractions[numeric[4]] || 0)];
  }
  return [2, text];
}
function msCompareSizes(a, b) {
  const left = msSizeKey(a), right = msSizeKey(b);
  for (let i = 0; i < Math.max(left.length, right.length); i++) {
    if (left[i] === right[i]) continue;
    if (typeof left[i] === 'number' && typeof right[i] === 'number') return left[i] - right[i];
    return String(left[i] || '').localeCompare(String(right[i] || ''), 'sv', {numeric:true, sensitivity:'base'});
  }
  return 0;
}
if (!customElements.get('ms-size-options')) {
  customElements.define('ms-size-options', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('sort-sizes')) return;
      const sort = () => {
        const list = this.querySelector('select') || this;
        const selected = list.tagName === 'SELECT' ? list.value : null;
        const children = [...list.children].filter(child => child.hasAttribute('data-size-value'));
        const sorted = [...children].sort((a, b) => msCompareSizes(a.dataset.sizeValue, b.dataset.sizeValue));
        if (sorted.some((child, index) => child !== children[index])) {
          sorted.forEach(child => list.append(child));
          if (selected !== null) list.value = selected;
        }
      };
      this.observer = new MutationObserver(sort);
      this.observer.observe(this, {childList:true, subtree:true});
      sort();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
